const release = '1.15.3'

module.exports = release



//////////////////
// WEBPACK FOOTER
// ./release.js
// module id = immm
// module chunks = 1624